module.exports = __webpack_public_path__ + "img/head-three.d11e9615.png";